import render from './render'

export default {
  name: 'SendingsTasksType',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
